import React, { useState, useEffect } from 'react';
import { Result, Button, Typography, Collapse, message } from 'antd';
import { ArrowLeftOutlined, CopyOutlined, CheckOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCurrentUserRole } from 'modules/utilities/utility';
import secureLocalStorage from 'react-secure-storage';

const { Text, Paragraph } = Typography;

const Error403 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [copied, setCopied] = useState(false);

  const errorInfo = {
    path: location.state?.attemptedPath || location.pathname,
    timestamp: new Date().toISOString(),
    role: getCurrentUserRole(),
    email: secureLocalStorage.getItem('email') || 'unknown',
  };

  useEffect(() => {
    console.warn('[Error403] Access denied', errorInfo);
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleCopy = () => {
    const text = Object.entries(errorInfo)
      .map(([k, v]) => `${k}: ${v}`)
      .join('\n');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        message.success('Error details copied');
        setTimeout(() => setCopied(false), 2000);
      });
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      message.success('Error details copied');
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const detailItems = [
    {
      key: '1',
      label: <Text type="secondary" style={{ fontSize: 13 }}>Error Details</Text>,
      children: (
        <div>
          <div style={{
            background: '#f5f5f5',
            borderRadius: 8,
            padding: '12px 16px',
            fontFamily: 'monospace',
            fontSize: 13,
            lineHeight: 1.8,
            marginBottom: 12,
          }}>
            {Object.entries(errorInfo).map(([k, v]) => (
              <div key={k}>
                <Text type="secondary">{k}:</Text>{' '}
                <Text strong>{v}</Text>
              </div>
            ))}
          </div>
          <Button
            size="small"
            icon={copied ? <CheckOutlined /> : <CopyOutlined />}
            onClick={handleCopy}
          >
            {copied ? 'Copied!' : 'Copy Details'}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      padding: 24,
    }}>
      <Result
        status="403"
        title={
          <span>
            <LockOutlined style={{ marginRight: 8 }} />
            403
          </span>
        }
        subTitle="You don't have permission to access this page."
        style={{ maxWidth: 560 }}
        extra={
          <div>
            <Button icon={<ArrowLeftOutlined />} onClick={handleGoBack} style={{ marginBottom: 24 }}>
              Go Back
            </Button>
            <Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 16 }}>
              If you think this is a mistake,{' '}
              <a href="mailto:sultantippu@traya.health">contact support</a>.
            </Paragraph>
            <Collapse
              ghost
              items={detailItems}
              style={{ textAlign: 'left' }}
            />
          </div>
        }
      />
    </div>
  );
};

export default Error403;
